<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="10"
            class="elevation-1"
            @click:row="view"
        >
            <template v-slot:top>
                <v-row class="mx-2">
                     <v-col cols="4">
                    <v-select label="กลุ่มงานบริการ" :items="groups">
                    </v-select>
                </v-col>
                <v-col cols="4">
                    <v-select
                        :items="months"
                        label="ข้อมูลของเดือน">
                    </v-select>
                </v-col>
                </v-row>
               
            </template>
           <template v-slot:[`item.data-table-select`]="{ item }">
            <v-icon
                small
                @click="view(item)"
            >
                delete
            </v-icon>
        </template>
        </v-data-table>

        <v-dialog v-model="dialog" width="50%">
            <v-card outlined>
                <v-card-title ><strong>Member Log detail</strong></v-card-title>
                <v-divider class="ma-2"></v-divider>
                <v-data-table
                    :headers="subHeaders"
                    :items="subItems"
                    :items-per-page="10"
                    class="elevation-1"
                >
                </v-data-table>
                <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = false"> ปิด</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
  
</template>

<script>
export default {
    name: "Data2_3",
    data: () => ({
        dialog: false,
        groups: ["All", "กลุ่มงาน A"],
        months: [
            'มกราคม',
            'กุมภาพันธ์',
            'มีนาคม',
            'เมษายน',
            'พฤษภาคม',
            'มิถุนายน',
            'กรกฎาคม',
            'สิงหาคม',
            'กันยายน',
            'ตุลาคม',
            'พฤษจิกายน',
            'ธันวาคม'
        ],
        headers: [
            {text: 'รายชื่อ Member', value: 'memberName'},
            {text: 'ถูกนัดหมาย', value: 'appoint'},
            {text: 'จองคิว', value: 'reserve'},
            {text: 'ถูกยกเลิกนัด', value: 'staffCancel'},
            {text: 'ยกเลิกนัดเอง', value: 'memberCancel'},
            {text: 'มาตรงเวลา', value: 'onTime'},
            {text: 'มาสาย', value: 'late'},
            {text: 'มาก่อนเวลา', value: 'beforeTime'},
            {text: 'ไม่มา', value: 'missing'}
            ],
        desserts: [
            {'memberName': 'นาย ก คนแรก', 'appoint': 20, 'reserve': 10, 'staffCancel': 5,
              'memberCancel': 2, 'onTime': 5, 'late': 2, 'beforeTime': 3, 'missing': 0 },
            {'memberName': 'นาย ข คนรอง', 'appoint': 20, 'reserve': 10, 'staffCancel': 5,
              'memberCancel': 2, 'onTime': 5, 'late': 2, 'beforeTime': 3, 'missing': 0 },
            {'memberName': 'นาย ค คนท้าย', 'appoint': 20, 'reserve': 10, 'staffCancel': 5,
              'memberCancel': 2, 'onTime': 5, 'late': 2, 'beforeTime': 3, 'missing': 0 }
        ],
        subHeaders: [
            {text: 'วันที่', value: 'date'},
            {text: 'Activity', value: 'activity'},
            {text: 'Group', value: 'group'},
        ],
        subItems: [
            {'date': '01/01/2021', 'activity': 'Login', 'group': 'Group A'},
            {'date': '01/01/2021', 'activity': 'Logout', 'group': 'Group A'},
            {'date': '02/01/2021', 'activity': 'Login', 'group': 'Group A'},
            {'date': '02/01/2021', 'activity': 'Logout', 'group': 'Group A'},
        ]
    }),
    methods: {
        view() {
            alert('a');
            this.dialog = true;
            
        }
    }
}
</script>